import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {SEWING_PARTNER} from "../../../../helpers/typePartner"

// Cột thông tin nhận hàng: chỉ đối tác May mới có
class ColReceiver extends Component {
    render() {
        const {type, value} = this.props

        if (type !== SEWING_PARTNER) {
            return <td className='ColReceiver text-muted'>Không áp dụng</td>
        }

        return (
            <td className='ColReceiver'>
                {value ? value : <span className='text-muted'>Chưa có</span>}
            </td>
        )
    }
}

ColReceiver.propTypes = {
    type: PropTypes.string,
    value: PropTypes.string,
}

export default ColReceiver
